export default __webpack_public_path__ + "static/media/fazemos.eed4eab1.svg";